<template>
  <b-button
    id="coi-action-bar-mark-parcel-loss-btn"
    size="sm"
    variant="primary"
    @click="
      () => {
        modalState = true;
        getSpareParts();
      }
    "
    :disabled="disabled"
    block
    ><!-- root-button -->
        Verlustsendung
        <b-modal
            v-model="modalState"
            id="modal-import-rule-set"
            title="Verlustsendung"
            @ok="submit()"
            size="md"
            cancel-title="Abbrechen"
        ><!-- modal -->
            <b-row>
                <span class="px-4 pb-3">Diese Bestellung wirklich als Verlustsendung markieren und neu bestellen?</span>
            </b-row>
            <b-row class="px-2">
                <div class="pl-3 d-inline-flex">
                   <span class="pt-1">Menge:</span>
                </div>
                <b-col>
                    <b-input-group size="sm">
                        <b-input-group-prepend>
                            <b-button variant="outline-secondary" @click="decrementAmount()">-</b-button>
                        </b-input-group-prepend>
                        <b-form-input v-model="payload.amount" :state="validateAmount" style="max-width:100px;text-align: center" />
                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="incrementAmount()">+</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="px-4 pt-3">
                <b-form-checkbox
                    id="checkbox-reorder-article"
                    name="checkbox-reorder-article"
                    v-model="payload.reorderArticle"
                    :disabled="disableCheckbox"
                ><!-- checkbox -->
                Artikel beim Händler bestellen
                </b-form-checkbox>
            </b-row>
            <b-row class="px-4 pt-3">
                <div class="pl-3 d-inline-flex">
                  <span class="pt-1">Ersatzteile:</span>
                </div>
                <b-col>
                    <b-form-group>
                        <b-form-select
                            v-model="payload.selectedSparePartMaterialId"
                            :options="spareParts"
                            size="sm"
                            text-field="name"
                            value-field="id"
                            class="w-auto"
                        >
                            <template #first>
                                <option :value="null"> Keine </option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
            v-model="modalSuccessState"
            id="modal-success-dialog"
            title="Verlustsendung"
            size="sm"
            centered
            hide-footer
            @hidden="() => { this.modalState = false }"
        ><!-- modal -->
          {{ isNaN(customerOrderIdNewDelivery) ? customerOrderIdNewDelivery : "Verlustsendung erfolgreich erstellt." }}
            <div slot="modal-footer" class="w-100">
               <b-button
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="success"
                  @click="() => {this.modalState = false; this.modalSuccessState = false }"
               >schliessen</b-button>
            </div>
        </b-modal>
        <modal-error-component v-model="modalError"></modal-error-component>
    </b-button>
</template>
<script>
import {useUserPreferenceStore} from "../../stores/UserPreferenceStore";
import ModalErrorComponent from "../ModalErrorComponent.vue";
export default {
	components: {ModalErrorComponent},
	setup(){
		const userPreferenceStore = useUserPreferenceStore();
		return {userPreferenceStore}
	},
    props: ['customerOrder', 'orderStates', 'vendors', 'marketAccounts'], // TODO check if all props are necessary
    data() {
        return {
            modalState: false,
            modalSuccessState: false,
            payload: {
                customerOrderId: this.customerOrder.id,
                reorderArticle: false,
                amount: this.customerOrder.customerorderitems[0].quantity,
                selectedSparePartMaterialId: null,
            },
            spareParts: [],
            customerOrderIdNewDelivery : null,
						modalError: {
							show: false,
							message: "unpopulated",
							error: "unpopulated",
							title: "unpopulated"
						},
        }
    },
    watch: {
	    'payload.selectedSparePartMaterialId'(newValue, oldValue) {
		    // if reorderArticle is false and if a spare part is selected and if the selected spare part is Case or Adapter the reorderArticle checkbox should be checked
		    if (!this.payload.reorderArticle) {
			    this.payload.reorderArticle = this.payload.selectedSparePartMaterialId !== null &&
					    [12221005, 12087181].includes(this.payload.selectedSparePartMaterialId);
		    }
	    }
    },
    computed: {
        validateAmount() {
            return (this.payload.amount >= 1) && Number.isInteger(parseInt(this.payload.amount));
        },
		    disableCheckbox(){
			    return [12221005, 12087181].includes(this.payload.selectedSparePartMaterialId);
		    },
	    disabled: function() {
		    // TODO *Nicht bei Verlustsendungen Normale orders
		    return ( this.orderStates.codes.DONE !== this.customerOrder.orderState
						    && this.orderStates.codes.REFUND !== this.customerOrder.orderState
						    && this.orderStates.codes.REFUND_OK !== this.customerOrder.orderState )
				    || (this.customerOrder.marketAccountId >= 10000) // Für verlustsendung immer deaktiviert
				    || (this.customerOrder.marketAccountId > 1000  && this.userPreferenceStore.coi.isMaster === true) // Für Slave Bestellungen im Mastersystem auch deaktiveren
	    }
    },
  methods: {
    submit() {
      axios
        .post("/customerorder/action/markparcelloss", this.payload)
        .then((response) => {
          this.modalSuccessState = true;
          this.openInNewTab(
            `/customerorder/${response.data.customerOrderIdNewDelivery}`,
          );
        })
        .catch((error) => {
					this.modalError = {
						show: true,
						title: "Fehler beim Laden der Ersatzteile",
						message: "Ein Fehler beim Laden der Ersatzteile ist aufgetreten. Bitte versuchen Sie es später erneut.",
						error: error.response.data ? JSON.stringify(error) : error.message
					}
        });
    },
    incrementAmount() {
      this.payload.amount = parseInt(this.payload.amount) + 1;
    },
    decrementAmount() {
      if (this.payload.amount > 1)
        this.payload.amount = parseInt(this.payload.amount) - 1;
    },
    openInNewTab(url) {
      var win = window.open(url, "_blank");
      win.focus();
    },
    getSpareParts() {
      axios
        .get("/material/spare_parts")
        .then((response) => {
          this.spareParts = response.data;
        })
        .catch((error) => {
          console.error(error);
          alert(
            "Ein Fehler beim Laden der Ersatzteile ist aufgetreten: " +
              error.message,
          );
        });
    },
  },
};
</script>
